<template lang="pug">
  v-layout.column
    v-dialog(width="50%" v-model="modifLayers" persistent)
      v-card
        v-card-title.create-conf
          v-layout
            v-flex.xs10.offset-xs1
              .headline.text-xs-center.white--text.font-style-Roboto.font-weight-bold CONFIGURER LES COUCHES
        v-card-text
          v-layout.column.margin
            .title Couches actives
            v-layout.space.align-center.justify-space-between
              v-layout.align-center.justify-center.content.image-normal
                .textCheckbox Plan
              v-checkbox.checkbox-layers-style.mt-0.pt-2.pb-1(
                :input-value="!this.config.carto.normalState"
                hide-details :color="color"
                @change="(value) => { changeConfLayer(value, 'normalState', 'normal') }"
              )
            v-layout.space.align-center.justify-space-between
              v-layout.align-center.justify-center.content.image-terrain
                .textCheckbox Terrain
              v-checkbox.checkbox-layers-style.mt-0.pt-2.pb-1(
                :input-value="!this.config.carto.terrainState"
                hide-details :color="color"
                @change="(value) => { changeConfLayer(value, 'terrainState', 'terrain') }"
              )
            v-layout.space.align-center.justify-space-between
              v-layout.align-center.justify-center.content.image-satellite
                .textCheckbox Satellite
              v-checkbox.checkbox-layers-style.mt-0.pt-2.pb-1(
                :input-value="!this.config.carto.satelliteState"
                hide-details :color="color"
                @change="(value) => { changeConfLayer(value, 'satelliteState', 'satellite') }"
              )
          v-layout.column.margin.mt-4
            .title Couche par défault
            v-layout.space.align-center.justify-space-between
              v-select(
                v-model="selectButton"
                :items="listSelection"
                @change="(value) => { clickRadio(value) }"
              )
          v-layout.column.space-config-terrain(v-if="!this.confLayers.terrainState")
            .title Configuration de Terrain
            v-container.space-container
              .titreTerrain.mt-3 Intensité des ombres de relief
              v-slider(
                v-if="etatTerrain"
                :min="1" :max="3" :step="1"
                v-model="typeIntensities"
                :tick-labels="intensities"
                tick-size="0"
                :color="color"
                @change="(value) => changeStyle(intensity_ids[value-1])"
                hide-details
              )
              .titreTerrain.mt-2 Courbes de niveau
              v-layout
                v-checkbox.checkbox-layers-style.mt-0.pt-2.pb-1(
                  :input-value="this.confLayers.elevation"
                  hide-details :color="color"
                  @change="(value) => { changeStateElevation(value)}"
                )
                template(v-slot:label)
                  .text-label Afficher les courbes de niveau (uniquement sur les zooms de 14 à 16)
          v-layout.justify-end
            v-btn.grey--text.margin-button(color="#eee" @click="modifLayers = false") ANNULER
            v-btn.margin-button(color="#e7523e" @click="validateConfLayers") VALIDER
    v-dialog(width="50%" v-model="modifZoom" persistent)
      v-card
        v-card-title.create-conf
          v-layout
            v-flex.xs10.offset-xs1
              .headline.text-xs-center.white--text.font-style-Roboto.font-weight-bold CONFIGURER LE ZOOM
        v-card-text
          v-layout.column.align-center
            .info-zoom Les valeurs de zoom possibles sont comprises entre 6 et 18
            v-layout.align-center.justify-space-between.zone
              .text Zoom minimum
              input.input-style(type="number" v-model="minZoom" @blur="checkZoom('minZoom')")
            v-layout.align-center.justify-space-between.zone
              .text Zoom maximum
              input.input-style(type="number" v-model="maxZoom" @blur="checkZoom('maxZoom')")
            .erreur-zoom(v-if="erreurZoom") Les valeurs remplies sont incorrectes
          v-layout.justify-end
            v-btn.grey--text.margin-button(color="#eee"  @click="modifZoom=false") ANNULER
            v-btn.margin-button(color="#e7523e" @click="validateConfZoom") VALIDER
    v-flex.pl-5.override-flex()
      v-flex.flex-row
        .title Afficher les étiquettes
          i.pl-3.far.fa-question-circle.align-self-center.tooltip
            .bottom
              | En désactivant les étiquettes, cela désactivera les images wikipedia par la même occasion.
              br
              | Les modifications ne sont pas visibles sur cette interface, mais seront visibles sur le site.
        v-layout.margin.align-center.mt-3
          v-layout.align-center.width-first-column
            .illustration-popup
          v-layout.width-second-column
            v-checkbox.mt-0.pt-2.pb-1(
              :input-value="config.map.popup!=null?config.map.popup:true"
              hide-details :color="color"
              @change="(value) => { changePopup(value) }"
            )
        .title Afficher les images wikipedia
          i.pl-3.far.fa-question-circle.align-self-center.tooltip
            .bottom Les modifications ne sont pas visibles sur cette interface, mais seront visibles sur le site.
        v-layout.margin.align-center.mt-3
          v-layout.align-center.width-first-column
            .illustration-wikipedia
          v-layout.width-second-column
            v-checkbox.mt-0.pt-2.pb-1(
              :input-value="config.map.wikidata!=null?config.map.wikidata:true"
              hide-details :color="color"
              @change="(value) => { changeWikipedia(value) }"
            )
      .title Plein écran
      v-layout.margin.align-center.mt-3
        v-layout.align-center.width-first-column
          .illustration-fullscreen.icon-font-zoom-in
        v-layout.width-second-column
          v-checkbox.mt-0.pt-2.pb-1(
            :input-value="config.fullscreen.state!=null?config.fullscreen.state:true"
            hide-details :color="color"
            @change="(value) => { changeScreenOptions(value, 'fullscreen') }"
          )
      .title Layers
      v-layout.margin.align-center.mt-3
        v-layout.align-center.width-first-column
          .illustration-layers
        v-layout.width-second-column
          v-checkbox.mt-0.pt-2.pb-1(
              :input-value="config.carto.state!=null?config.carto.state:true"
              hide-details :color="color"
              @change="(value) => { changeScreenOptions(value, 'carto') }"
            )
          v-btn.conf-button-style(@click="modifLayers = true")
            v-icon.material-icons settings
      .title Zoom
      v-layout.margin.align-center.mt-3
        v-layout.align-center.width-first-column
          .div-zoom
            .illustration-zoom.plus +
            .illustration-zoom -
        v-layout.width-second-column
          v-checkbox.mt-0.pt-2.pb-1(
            :input-value="config.zoom.state!=null?config.zoom.state:true"
            hide-details :color="color"
            @change="(value) => { changeScreenOptions(value, 'zoom') }"
          )
          v-btn.conf-button-style(@click="modifZoom = true")
            v-icon.material-icons settings
      .title Centrer sur ma position GPS
      v-layout.margin.align-center.mt-3
        v-layout.align-center.width-first-column
          .illustration-geoloc
        v-layout.width-second-column
          v-checkbox.mt-0.pt-2.pb-1(
            :input-value="config.locate.state!=null?config.locate.state:true"
            hide-details :color="color"
            @change="(value) => { changeScreenOptions(value, 'locate') }"
          )
      .title Recherche sur la carte
      v-layout.margin.align-center.mt-3
        v-layout.align-center.width-first-column
          .illustration-search
        v-layout.width-second-column
          v-checkbox.mt-0.pt-2.pb-1(
            :input-value="config.geosearch.state!=null?config.geosearch.state:true"
            hide-details :color="color"
            @change="(value) => { changeScreenOptions(value, 'geosearch') }"
          )
</template>

<script>

// .title Position des boutons sur la carte
// v-layout.margin.align-center.mt-3.width-position-element.slider
// v-slider(
// :min="1" :max="3" :step="1"
// v-model="typePositions"
// :tick-labels="positions"
// tick-size="0"
// :color="color2"
// @change="(value) => { changeScreenOptions(positions_ids[value-1], 'position') }"
// hide-details
// )

import RcColorPicker from '@/components/RcColorPicker.vue';
import mixin from '@/mixins/Rc.mixin.vue';

export default {
  props: {
    config: Object,
  },
  mixins: [mixin],
  data() {
    return {
      modifLayers: false,
      modifZoom: false,
      etatTerrain: true,
      erreurZoom: false,
      selectButton: 'Plan',
      confLayers: this.config.carto, // If button is active
      confDefault: this.config.theme, // If layer is active
      minZoom: this.config.map.minZoom,
      maxZoom: this.config.map.maxZoom,
      typeIntensities: 2,
      listSelection: ['Plan', 'Terrain', 'Satellite'],
      intensities: ['Faible', 'Moyenne', 'Élevée'],
      intensity_ids: ['light', 'true', 'dark'],
      // typePositions: 3,
      // positions: ['Gauche','Droite'],
      // positions_ids: ['topleft','topright'],
    };
  },
  components: {
    RcColorPicker,
  },
  mounted() {
    function getDefaultValue(confDefault) {
      if (confDefault.terrain) return 'Terrain';
      if (confDefault.satellite) return 'Satellite';
      return 'Plan';
    }
    function getIntensities(intensities) {
      if (intensities === 'light') return 1;
      if (intensities === 'dark') return 3;
      return 2;
    }
    this.selectButton = getDefaultValue(this.confDefault);
    this.typeIntensities = getIntensities(this.confLayers.terrain);
    // this.typePositions = getPositions(this.config);

    // function getPositions(conf){
    //   if (conf.fullscreen.position==="topleft"||conf.carto.position==="topleft"
    //     ||conf.zoom.position==="topleft"||conf.locate.position==="topleft"
    //     ||conf.geosearch.position==="topleft"
    //   ) return 1;
    //   return 2;
    // }
  },
  watch: {
    config() {
      this.transientParams = this.filterConfig(this.config);
    },
  },
  methods: {
    // Set whether a Layer is active
    changeConfLayer(value, type, id) {
      if (value) {
        this.$set(this.confLayers, [type], '');
        if (id === 'normal' && this.confLayers.terrainState && this.confLayers.satelliteState) {
          this.selectButton = 'Plan';
          this.clickRadio('Plan');
        } else if (id === 'terrain' && this.confLayers.normalState && this.confLayers.satelliteState) {
          this.selectButton = 'Terrain';
          this.clickRadio('Terrain');
        } else if (id === 'satellite' && this.confLayers.normalState && this.confLayers.terrainState) {
          this.selectButton = 'Satellite';
          this.clickRadio('Satellite');
        }
        if (
          (this.confLayers.normalState === '' && this.confLayers.terrainState === '')
          || (this.confLayers.normalState === '' && this.confLayers.satelliteState === '')
          || (this.confLayers.terrainState === '' && this.confLayers.satelliteState === '')
        ) {
          this.config.carto.state = true;
        }
      } else {
        this.$set(this.confLayers, [type], 'display:none');
        if (
          (this.confLayers.normalState === 'display:none' && this.confLayers.terrainState === 'display:none')
          || (this.confLayers.normalState === 'display:none' && this.confLayers.satelliteState === 'display:none')
          || (this.confLayers.terrainState === 'display:none' && this.confLayers.satelliteState === 'display:none')
        ) {
          this.config.carto.state = false;
        }
        if (id === 'terrain' && this.confDefault.terrain) {
          if (!this.confLayers.normalState) {
            this.selectButton = 'Plan';
            this.clickRadio('Plan');
          } else if (!this.confLayers.satelliteState) {
            this.selectButton = 'Satellite';
            this.clickRadio('Satellite');
          }
        } else if (id === 'satellite' && this.confDefault.satellite) {
          if (!this.confLayers.normalState) {
            this.selectButton = 'Plan';
            this.clickRadio('Plan');
          } else if (!this.confLayers.terrainState) {
            this.selectButton = 'Terrain';
            this.clickRadio('Terrrain');
          }
        } else if (!this.confLayers.terrainState) {
          this.selectButton = 'Terrain';
          this.clickRadio('Terrain');
        } else if (!this.confLayers.satelliteState) {
          this.selectButton = 'Satellite';
          this.clickRadio('Satellite');
        }
      }
      this.listSelection = [];
      let i = 0;
      // eslint-disable-next-line no-plusplus
      if (!this.confLayers.normalState) { this.listSelection[i] = 'Plan'; i++; }
      // eslint-disable-next-line no-plusplus
      if (!this.confLayers.terrainState) { this.listSelection[i] = 'Terrain'; i++; }
      // eslint-disable-next-line no-plusplus
      if (!this.confLayers.satelliteState) { this.listSelection[i] = 'Satellite'; i++; }
      if (this.listSelection.length === 0) this.listSelection = ['Plan', 'Terrain', 'Satellite'];
    },
    // Activate/Desactivate Elevation levels
    changeStateElevation(value) {
      if (value) {
        this.confLayers.elevation = true;
        if (this.confDefault.terrain) this.confDefault.elevation = true;
      } else {
        this.confLayers.elevation = false;
        if (this.confDefault.terrain) delete (this.confDefault.elevation);
      }
    },
    changeStyle(intensity) {
      this.confLayers.terrain = intensity;
      if (this.confDefault.terrain) this.confDefault.terrain = intensity;
    },
    clickRadio(value) {
      if (value === 'Terrain') {
        if (!this.confLayers.elevation) delete (this.confDefault.elevation);
        else this.confDefault.elevation = true;
        this.confDefault.terrain = this.confLayers.terrain;
        delete (this.config.theme.satellite);
      } else if (value === 'Satellite') {
        delete (this.confDefault.terrain);
        delete (this.confDefault.elevation);
        this.confDefault.satellite = true;
      } else {
        delete (this.confDefault.terrain);
        delete (this.confDefault.elevation);
        delete (this.confDefault.satellite);
      }
    },
    // Useless ?
    setupTerrain(value) {
      // console.log('USELESS');
      if (value.length === 0) {
        this.etatTerrain = false;
        this.confLayers.elevation = false;
        this.confLayers.terrain = 'disabled';
      } else if (value.length === 1 && value[0] === 'elevation') {
        this.etatTerrain = false;
        this.confLayers.elevation = true;
        this.confLayers.terrain = 'disabled';
      } else if (value.length === 1 && value[0] === 'terrain') {
        this.etatTerrain = true;
        this.confLayers.elevation = false;
        this.confLayers.terrain = 'true';
      } else {
        this.etatTerrain = true;
        this.confLayers.elevation = true;
        this.confLayers.terrain = 'true';
      }
    },
    changeScreenOptions(value, type) {
      if (type === 'carto' && value === true) {
        if (
          (this.confLayers.normalState === 'display:none' && this.confLayers.terrainState === 'display:none')
          || (this.confLayers.normalState === 'display:none' && this.confLayers.satelliteState === 'display:none')
          || (this.confLayers.terrainState === 'display:none' && this.confLayers.satelliteState === 'display:none')
        ) {
          this.confLayers.normalState = '';
          this.confLayers.terrainState = '';
          this.confLayers.satelliteState = '';
        }
      }
      this.loading = true;
      this.config[type].state = value;
      this.transientParams = this.filterConfig(this.config);
      this.$emit('changed', this.transientParams);
    },
    // Save changes
    validateConfLayers() {
      this.modifLayers = false;
      // if(!this.confLayers.normalState){}
      this.config.carto = this.confLayers;
      this.config.theme = this.confDefault;
      this.transientParams = this.filterConfig(this.config);
      this.$emit('changed', this.transientParams);
    },
    validateConfZoom() {
      if (parseInt(this.minZoom) > parseInt(this.maxZoom)) {
        this.erreurZoom = true;
      } else {
        this.modifZoom = false;
        this.erreurZoom = false;
        const oldConfig = this.config;
        oldConfig.map.minZoom = this.minZoom;
        oldConfig.map.maxZoom = this.maxZoom;
        this.transientParams = this.filterConfig(this.config);
        this.$emit('changed', this.transientParams);
      }
    },
    checkZoom(value) {
      if (this[value] > 18) this[value] = 18;
      else if (this[value] < 6) this[value] = 6;
    },
    changePopup(value) {
      this.config.map.popup = value;
      this.transientParams = this.filterConfig(this.config);
      this.$emit('changed', this.transientParams);
      if (!value) {
        this.changeWikipedia(false);
      }
    },
    changeWikipedia(value) {
      this.config.map.wikidata = value;
      this.transientParams = this.filterConfig(this.config);
      this.$emit('changed', this.transientParams);
    },
  },
  computed: {
    color() {
      return this.isChoice ? '#e75239' : 'primary';
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-input--slider{
    margin-top:0 !important;
    font-size: 14px !important;
  }
  .width-first-column{
    width: 450px;
  }
  .width-second-column{
    width: 125px;
  }
  //.width-position-element{
  //  width: 220px;
  //}
  //.v-input__control {
  //  width: 100px;
  //}
  //.v-slider__ticks{
  //  border-color: #50C054 !important;
  //}

  .illustration-layers{
    width: 40px;
    height: 40px;
    background-size: 35px;
    background-position: center;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    background-image: url("https://tiles.touristicmaps.com/libs/layer_selector.png");
  }
  .illustration-zoom{
    width: 40px;
    height: 40px;
    font: bold 18px 'Lucida Console',Monaco,monospace;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .illustration-search{
    width: 40px;
    height: 40px;
    background-size: 20px;
    background-position: center;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    background-image: url("https://tiles.touristicmaps.com/libs/search.svg");
  }
  .illustration-geoloc{
    width: 40px;
    height: 40px;
    background-size: 20px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    background: no-repeat center url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZmlsbD0iIzQ0NCIgZD0iTTEyIDhjLTIuMjEgMC00IDEuNzktNCA0czEuNzkgNCA0IDQgNC0xLjc5IDQtNC0xLjc5LTQtNC00em04Ljk0IDNjLS40Ni00LjE3LTMuNzctNy40OC03Ljk0LTcuOTRWMWgtMnYyLjA2QzYuODMgMy41MiAzLjUyIDYuODMgMy4wNiAxMUgxdjJoMi4wNmMuNDYgNC4xNyAzLjc3IDcuNDggNy45NCA3Ljk0VjIzaDJ2LTIuMDZjNC4xNy0uNDYgNy40OC0zLjc3IDcuOTQtNy45NEgyM3YtMmgtMi4wNnpNMTIgMTljLTMuODcgMC03LTMuMTMtNy03czMuMTMtNyA3LTcgNyAzLjEzIDcgNy0zLjEzIDctNyA3eiIvPjwvc3ZnPg==);
  }
  .illustration-fullscreen{
    width: 40px;
    height: 40px;
    background-size: 20px;
    background-position: center;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    content: "\e659";
  }
  .illustration-wikipedia{
    width: 40px;
    height: 40px;
    background-size: 35px;
    background-position: center;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    background-image: url("https://tiles.touristicmaps.com/libs/wikipedia.png");
  }
  .illustration-popup{
    width: 40px;
    height: 40px;
    background-size: 35px;
    background-position: center;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    background-image: url("https://tiles.touristicmaps.com/libs/popup.png");
  }
  .div-zoom{border-radius:4px; box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);}
  .plus{border-bottom: 1px solid #989898;}

  .text-layers{
    font-family: Roboto,sans-serif;
    margin-left: 10px;
  }

  .textCheckbox{
    font-family: Roboto,sans-serif;
    color: white;
    border: 1px solid white;
    background-color: #e75239;
    text-align: center;
    padding-top: 5px;
    width: 80px;
    height: 30px;
  }
  .content{
    box-shadow:inset 140px 0 rgba(231,82,57,.4);
    max-width:125px;
    height:50px;
  }
  .style-justify {
    display: flex;
    justify-content: flex-end;
    width: 145px;
  }
  .size-radio-button{
    width: 142px;
  }
  .image-normal{background-image: url("https://tiles.touristicmaps.com/libs/normal3x.png"); }
  .image-terrain{background-image: url("https://tiles.touristicmaps.com/libs/terrain3x.png");}
  .image-satellite{background-image: url("https://tiles.touristicmaps.com/libs/satellite3x.png"); }
  .checkbox-layers-style{
    flex: none;
  }

  input[type="radio"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    background: white;
    border: 2px solid #707070;
    width: 18px;
    height: 18px;
    border-radius: 100%;
  }
  input[type="radio"]:checked {
    background-color: #e75239;
    box-shadow: inset 0 0 0 3px white;
    border-color: #e75239;
  }

  input[type='range'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    overflow: hidden;
    width: 150px;
    border: 2px solid #e7523e;
    border-radius: 5px;
    background-color: white;
  }
  input[type='range']::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    height: 12px;
    color: #e7523e;
  }
  input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    width: 1px;
    height: 12px;
    cursor: ew-resize;
    background: #e7523e;
    box-shadow: -80px 0 0 80px #e7523e;
  }
  input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  .zone{
    width: 210px;
    margin-bottom: 20px;
  }
  .title{
    font-family: Roboto,sans-serif;
    font-weight: bold;
    color: #e7523e;
    font-size: 17px !important;
  }
  .margin{
    margin: 10px 20px 30px 20px;
  }
  .space{
    width: 200px;
    margin: 20px;
  }
  .space-container{
    width: 350px;
    margin: 5px 20px;
    padding: 0 !important;
  }
  .space-config-terrain{
    position: absolute;
    width:385px;
    top: 180px;
    left: 350px;
  }
  .text-radio-button{
    font-family: Roboto,sans-serif;
    font-weight: bold;
    color: #A1A1A1;
    margin-left: 10px;
  }
  .info-zoom{
    font-family: Roboto,sans-serif;
    font-style: italic;
    color: #A1A1A1;
    margin-bottom: 14px;
  }
  .erreur-zoom{
    font-family: Roboto,sans-serif;
    color: #FF2222 ;
    font-weight: bold;
    margin-bottom: 14px;
  }
  .text-label{
    font-family: Roboto,sans-serif;
    color: #A1A1A1;
    font-size: 14px;
  }
  .titreTerrain{
    font-family: Roboto,sans-serif;
    font-weight: bold;
    color: #A1A1A1;
    font-size: 15px;
  }
  .label-terrain-type {
    font-family: Roboto,sans-serif;
    font-weight: bold;
    color: #A1A1A1;
    padding-top:10px;
    margin-left:10px;
  }
  .titreColumn{
    font-family: Roboto,sans-serif;
    font-weight: bold;
    color: #A1A1A1;
  }

  .input-style {
    width: 80px;
    height: 40px;
    border: 2px solid #707070;
    text-align: center;
    font-family: Roboto,sans-serif;
    font-weight: bold;
    color: #A1A1A1;
  }
  input:focus{
    border: 2px solid #e7523e;
    outline:none;
  }
  .v-text-field__slot {
    margin-top: 0 !important;
  }
  .v-text-field {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  .conf-button-style{
    color: #e75239;
    margin: 0 !important;
    min-height: 0 !important;
    min-width: 50px !important;
  }
  .text-config{
    text-decoration:underline;
    text-transform: capitalize;
    color: #e7523e;
  }
  .text{
    font-family: Roboto,sans-serif;
    font-weight: bold;
    color: #A1A1A1;
  }
  .margin-button{
    margin-top: 5px !important;
    margin-right: 15px !important;
    color: #fafafa;
  }
  .layout.column.align-center.margin{
    margin-bottom: 20px;
  }
  .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat){
    background-color: transparent;
    text-transform: none;
  }
  .tooltip {
    display:inline-block;
    position:relative;
    text-align:left;
    color: rgba(0,0,0,.54);
    font-size: 14px;
  }
  .tooltip .bottom{
    min-width: 290px;
    padding: 10px 15px;
    top: 40px;
    left: 50%;
    position: absolute;
    z-index: 99999;
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
    color: #a1a1a1;
    background-color: #eee;
    -webkit-box-shadow: 0 1px 8px rgb(0 0 0 / 50%);
    box-shadow: 0 1px 8px rgb(0 0 0 / 50%);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 8px;
    font-weight: normal;
    font-size: 13px;
    font-family: Roboto,sans-serif;
    display: none;
  }
  .tooltip:hover .bottom{
    display:block;
  }
</style>
